import { __awaiter, __generator } from '../../../_virtual/_tslib.js';
import { defineComponent, toRef, ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from '@vue/composition-api';
import __vue_component__ from '../../SdsButtonIcon/SdsButtonIcon.vue.js';
import __vue_component__$3 from '../../SdsContentLoader/SdsContentLoader.vue.js';
import __vue_component__$1 from '../../SdsIcon/SdsIcon.vue.js';
import { respondToBelow, ScreenWidth } from '@superbet-group/web.lib.vue-utilities';
import __vue_component__$2 from '../../SdsDrawerSelect/SdsDrawerSelect.vue.js';
import __vue_component__$4 from '../../SdsInputSearch/SdsInputSearch.vue.js';
import __vue_component__$5 from '../../SdsOverlaySelect/SdsOverlaySelect.vue.js';
import __vue_component__$6 from '../../SdsInputText/SdsInputText.vue.js';
import __vue_component__$7 from '../../SdsFlag/SdsFlag.vue.js';
import { useOptionsSearch } from '../../SdsInputDropdown/useOptionsSearch.js';
import { isPointInsideRect } from '../../utils/isPointInsideRect.js';
import { useRestrictChars } from '../useRestrictChars.js';

var script = defineComponent({
    name: 'SdsInputPhone',
    props: {
        label: {
            type: String,
            required: true,
        },
        selectedPrefix: {
            type: String,
            required: false,
            default: '',
        },
        phoneNumber: {
            type: String,
            required: false,
            default: '',
        },
        options: {
            type: Array,
            required: true,
        },
        areOptionsLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
        name: {
            type: String,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errorMessage: {
            type: String,
            required: false,
            default: '',
        },
        autocomplete: {
            type: String,
            required: false,
            default: 'off',
        },
        isCheckmarkEnabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isRequired: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    /* eslint-disable sonarjs/no-duplicate-string */
    emits: [
        'update:selectedPrefix',
        'update:phoneNumber',
        'focus',
        'blur',
    ],
    setup: function (props, _a) {
        var emit = _a.emit;
        var options = toRef(props, 'options');
        var rootElement = ref(null);
        var phoneInput = ref(null);
        var prefixInput = ref(null);
        var dropdown = ref(null);
        var _b = useOptionsSearch(options), query = _b.query, hasQuery = _b.hasQuery, hasNoResults = _b.hasNoResults, displayedOptions = _b.displayedOptions, clearQuery = _b.clearQuery, updateQuery = _b.updateQuery;
        var isTouched = ref(false);
        var isPhoneInputFocused = ref(false);
        var isPrefixInputFocused = ref(false);
        var isFocused = computed(function () { return isPhoneInputFocused.value || isPrefixInputFocused.value; });
        var positioning = ref('bottom');
        var isInvalid = computed(function () { return props.isRequired && (!!props.errorMessage || !props.selectedPrefix || !props.phoneNumber && isTouched.value && !isFocused.value); });
        var isExpanded = ref(false);
        var hasAssignedValue = computed(function () { return props.options.some(function (option) { return option.value === props.selectedPrefix; }); });
        var selectedPrefixDisplayInfo = computed(function () {
            var targetPrefix = props.options.find(function (option) { return option.value === props.selectedPrefix; });
            return {
                label: targetPrefix === null || targetPrefix === void 0 ? void 0 : targetPrefix.name,
                flag: targetPrefix === null || targetPrefix === void 0 ? void 0 : targetPrefix.flag,
            };
        });
        var stateIcon = computed(function () {
            if (!isFocused.value && isInvalid.value) {
                return 'status-danger-filled';
            }
            else if (!isFocused.value && props.isCheckmarkEnabled && hasAssignedValue.value) {
                return 'status-checkmark';
            }
            else if (isFocused.value && (hasQuery.value || hasAssignedValue.value)) {
                return 'navigation-close-alt-filled';
            }
            else {
                return '';
            }
        });
        function onSearchInputChange(value) {
            updateQuery(value !== null && value !== void 0 ? value : '');
            if (hasQuery.value) {
                isExpanded.value = true;
            }
        }
        function toggleOptions(event) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (props.isDisabled) {
                                return [2 /*return*/];
                            }
                            event.stopPropagation();
                            isExpanded.value = !isExpanded.value;
                            return [4 /*yield*/, nextTick()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function closeDropdownOnClickOutside(mouseEvent) {
            var _a;
            var domRects = [
                (_a = dropdown.value) === null || _a === void 0 ? void 0 : _a.$el,
                prefixInput.value,
                document.querySelector('.e2e-dropdown-input-modal'),
            ].filter(function (it) { return it != null; }).map(function (it) { return it.getBoundingClientRect(); });
            var point = new DOMPoint(mouseEvent.clientX, mouseEvent.clientY);
            if (domRects.every(function (domRect) { return domRect && !isPointInsideRect(point, domRect); })) {
                isExpanded.value = false;
                clearQuery();
            }
        }
        function passFocusToPhoneInput() {
            var _a;
            (_a = phoneInput.value) === null || _a === void 0 ? void 0 : _a.focus();
        }
        function selectOption(option) {
            if (option.value === props.selectedPrefix) {
                clearQuery();
                isExpanded.value = false;
                return;
            }
            else {
                emit('update:selectedPrefix', option.value);
                clearQuery();
                isExpanded.value = false;
            }
        }
        function onPhoneNumberInput(inputEvent) {
            var _a;
            emit('update:phoneNumber', (_a = inputEvent.target) === null || _a === void 0 ? void 0 : _a.value);
        }
        function closeWithEsc(event) {
            if (isExpanded.value) {
                toggleOptions(event);
            }
        }
        function emitFocusPhoneInput(event) {
            isPhoneInputFocused.value = true;
            isTouched.value = true;
            emit('focus', event);
        }
        function emitBlurPhoneInput(event) {
            isPhoneInputFocused.value = false;
            emit('blur', event);
        }
        watch(isExpanded, function (expanded) {
            if (!expanded || !rootElement.value) {
                return;
            }
            var distanceFromTopWithScroll = rootElement.value.getBoundingClientRect().top;
            var distanceFromBottomWithScroll = window.innerHeight - rootElement.value.getBoundingClientRect().bottom;
            if (distanceFromTopWithScroll > distanceFromBottomWithScroll) {
                positioning.value = 'top';
            }
            else {
                positioning.value = 'bottom';
            }
        });
        onMounted(function () {
            window.addEventListener('mousedown', closeDropdownOnClickOutside);
        });
        onBeforeUnmount(function () {
            window.removeEventListener('mousedown', closeDropdownOnClickOutside);
        });
        var _c = useRestrictChars('tel'), restrictBeforeInput = _c.restrictBeforeInput, sanitizeInput = _c.sanitizeInput;
        function pasteWithValidCharacters(pasteEvent) {
            var _a;
            var pastedData = ((_a = pasteEvent.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text/plain')) || '';
            var sanitizedData = sanitizeInput(pastedData);
            pasteEvent.preventDefault();
            emit('update:phoneNumber', sanitizedData);
        }
        return {
            dropdown: dropdown,
            rootElement: rootElement,
            phoneInput: phoneInput,
            prefixInput: prefixInput,
            query: query,
            hasNoResults: hasNoResults,
            displayedOptions: displayedOptions,
            selectedPrefixDisplayInfo: selectedPrefixDisplayInfo,
            stateIcon: stateIcon,
            isInvalid: isInvalid,
            isTouched: isTouched,
            isFocused: isFocused,
            isPhoneInputFocused: isPhoneInputFocused,
            isExpanded: isExpanded,
            positioning: positioning,
            isErrorIcon: computed(function () { return !isFocused.value && isInvalid.value; }),
            isCheckmarkIcon: computed(function () { return !isFocused.value && !isInvalid.value && isTouched.value; }),
            isMobileLayout: computed(function () { return respondToBelow(ScreenWidth.tLg); }),
            passFocusToPhoneInput: passFocusToPhoneInput,
            restrictBeforeInput: restrictBeforeInput,
            pasteWithValidCharacters: pasteWithValidCharacters,
            onSearchInputChange: onSearchInputChange,
            onPhoneNumberInput: onPhoneNumberInput,
            emitFocusPhoneInput: emitFocusPhoneInput,
            emitBlurPhoneInput: emitBlurPhoneInput,
            toggleOptions: toggleOptions,
            selectOption: selectOption,
            closeWithEsc: closeWithEsc,
        };
    },
    components: {
        SdsButtonIcon: __vue_component__,
        SdsIcon: __vue_component__$1,
        SdsDrawerSelect: __vue_component__$2,
        SdsContentLoader: __vue_component__$3,
        SdsInputSearch: __vue_component__$4,
        SdsOverlaySelect: __vue_component__$5,
        SdsInputText: __vue_component__$6,
        SdsFlag: __vue_component__$7,
    },
});

export default script;
